import { useCallback } from 'react'
import { isModuleFlagOpen, type ModuleConfig } from '../../config/moduleRegistry'
import { useFeatureFlags } from './useFeatureFlags'
import { usePermissions } from './auth'

/**
 * Registry `featureFlag` gate bound to the live flags + current role.
 * Used by Sidebar, Home and ModuleFlagGuard so the policy lives in one place.
 */
export function useModuleFlagGate() {
  const { isModuleFlagEnabled, isLoading } = useFeatureFlags()
  const { hasFullAccess } = usePermissions()
  const isAdmin = hasFullAccess()

  const isOpen = useCallback(
    (module: ModuleConfig | undefined): boolean =>
      !!module && isModuleFlagOpen(module, { isModuleFlagEnabled, isAdmin }),
    [isModuleFlagEnabled, isAdmin],
  )

  return { isModuleFlagOpen: isOpen, isLoading }
}
